import 'react-calendar/dist/Calendar.css'

import { CalendarIcon } from '@radix-ui/react-icons'
import { formatDate } from 'date-fns'
import Calendar from 'react-calendar'

import { cx } from '@/lib/cva-config'
import { Button } from '../button'
import { FormControl } from '../form'
import { Popover, PopoverContent, PopoverTrigger } from '../popover'

type FormFieldDatePickerProps = {
  date?: Date
  onSelect: (date?: Date) => void
  placeholder?: string
  disabled?: boolean
}

export function FormFieldDatePicker(props: FormFieldDatePickerProps) {
  const {
    date,
    onSelect,
    placeholder = 'Pick a date',
    disabled,
    ...rest
  } = props

  return (
    <Popover>
      <FormControl>
        <PopoverTrigger asChild>
          <Button
            variant={'outline'}
            disabled={disabled}
            className={cx(
              'justify-between text-left font-normal',
              !date && 'text-muted-foreground'
            )}
          >
            <span className="mr-auto">
              {date ? formatDate(date, 'PPP') : placeholder}
            </span>
            <CalendarIcon className="ml-2 h-4 w-4 text-red-600" />
          </Button>
        </PopoverTrigger>
      </FormControl>
      <PopoverContent className="w-auto p-0">
        <Calendar
          value={date}
          onChange={(_date) => {
            const newDate = _date as Date
            onSelect(newDate)
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
